/* eslint-disable radix */
import { getNewPayment } from './actions/userInformation/updatePaymentOptions';

window.CommunicationHandler = window.CommunicationHandler || {};

function parseQueryString(str) {
  const vars = [];
  let arr = [];
  if (str && str instanceof String) {
    arr = str.split('&');
  } else if (str && str.qstr) {
    arr = str.qstr.split('&');
  }
  let pair;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < arr.length; i++) {
    pair = arr[i].split('=');
    vars[pair[0]] = unescape(pair[1]);
  }
  return vars;
}

const CommunicationHandler = ({
  customer,
  paymentOptions,
  disableCreditCardInfoModal,
  enableCreditCardList,
  updatePaymentOptions,
}) => {
  window.CommunicationHandler.onReceiveCommunication = querystr => {
    const params = parseQueryString(querystr);
    const ifrm = document.getElementById('add_payment');
    switch (params.action) {
      case 'successfulSave': {
        ifrm.style.marginTop = '90%';
        getNewPayment(customer, paymentOptions).then(newPayments => {
          if (newPayments && newPayments.length) {
            newPayments.map(newPayment => updatePaymentOptions(newPayment));
          }

          disableCreditCardInfoModal();
          enableCreditCardList();
        });
        break;
      }

      case 'cancel': {
        disableCreditCardInfoModal();
        if (enableCreditCardList) {
          enableCreditCardList();
        }

        break;
      }
      case 'resizeWindow': {
        const w = parseInt(params.width);
        const h = parseInt(params.height);
        ifrm.style.width = `${w}px`;
        ifrm.style.height = `${h}px`;
        break;
      }
      case 'transactResponse': {
        ifrm.style.display = 'none';
        break;
      }
      default:
        break;
    }
  };

  return null;
};

export default CommunicationHandler;



// WEBPACK FOOTER //
// ./src/communicationHandler.js